module.exports = __webpack_public_path__ + "static/media/mdi_clock-fast.3f4b5b9d.svg";